// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__SudN9","rootSuccess":"CompleteLink_rootSuccess__3GdeL","rootFailure":"CompleteLink_rootFailure__1RWeK","isDisabled":"CompleteLink_isDisabled__1-IGC"};